import * as PIXI from "pixi.js";
import { config } from "./appConfig";
import { incrementValue, tweenFadeAppear } from "./utility";
import { restartGame, toggleVisibiltiyAndInteractivity } from "./gameLogic";
import { Spine } from "@esotericsoftware/spine-pixi-v7";
import { fruitData } from "./data";
import { bigWin, COMMENDATION, grandJackpot, majorJackpot, megaWin, minorJackpot, setCommendationType, ultraWin } from "./commendation";
import { containers, controlJackpotWinSpine, gameAssets } from "./gameUI";
import { playCoinAnimation, stopCoinAnimation } from "./coins";
import { playMainBg, playMainBg1, playMainBg2 } from "./soundManager";

export class winScreen {
    winTypes = Object.freeze({
        NONE: "NONE",
        NORMAL_WIN: "NORMAL_WIN",
        BIG_WIN: "BIG_WIN",
        MEGA_WIN: "MEGA_WIN",
        ULTRA_WIN: "ULTRA_WIN",
    });

    winContainer = null;
    backgroundBlur = null;
    loseMessage = null;
    winSpine = null;
    normalWinContainer = null;

    minorJackpotSpine = null;
    majorJackpotSpine = null;
    grandJackpotSpine = null;

    constructor() {
        this.winContainer = new PIXI.Container();
        this.normalWinContainer = new PIXI.Container();


        this.backgroundBlur = new PIXI.Graphics();
        this.backgroundBlur.beginFill(0, 0.5);
        this.backgroundBlur.drawRect(
            config.logicalWidth / 2 - 1080,
            config.logicalHeight / 2 - 2500,
            720,
            3300
        );
        this.backgroundBlur.endFill();
        this.backgroundBlur.initialX = 0;
        this.backgroundBlur.initialY = 0;
        this.backgroundBlur.finalX = 0;
        this.backgroundBlur.finalY = 0;
        this.backgroundBlur.interactive = false;
        this.winContainer.addChild(this.backgroundBlur, containers.coinsContainer);
        this.backgroundBlur.visible = false;
        this.winContainer.name = "win_container"

        this.createLoseText();

        this.winSpine = Spine.from({ skeleton: "winSpine", atlas: "winAtlas" });
        this.winSpine.x = 0;
        this.winSpine.y = 0;
        this.winSpine.scale.set(0.52)
        this.winSpine.state.timeScale = 1;
        this.winSpine.interactive = false;
        this.createWinText();
        this.createNormalWin();

        this.minorJackpotSpine = Spine.from({ skeleton: "jackpotSpine", atlas: "jackpotAtlas" });
        this.minorJackpotSpine.x = 0;
        this.minorJackpotSpine.y = 0;
        this.minorJackpotSpine.state.timeScale = 1;
        this.minorJackpotSpine.interactive = false
        this.minorJackpotSpine.scale.set(0.5)

        this.majorJackpotSpine = Spine.from({ skeleton: "jackpotSpine", atlas: "jackpotAtlas" });
        this.majorJackpotSpine.x = 0;
        this.majorJackpotSpine.y = 0;
        this.majorJackpotSpine.state.timeScale = 1;
        this.majorJackpotSpine.interactive = false
        this.majorJackpotSpine.scale.set(0.5)

        this.grandJackpotSpine = Spine.from({ skeleton: "jackpotSpine", atlas: "jackpotAtlas" });
        this.grandJackpotSpine.x = 0;
        this.grandJackpotSpine.y = 0;
        this.grandJackpotSpine.state.timeScale = 1;
        this.grandJackpotSpine.interactive = false
        this.grandJackpotSpine.scale.set(0.5)

        this.winContainer.addChild(this.winSpine, this.normalWinContainer, this.minorJackpotSpine,
            this.majorJackpotSpine,
            this.grandJackpotSpine)
        this.createJackpotWinText()
    }

    createNormalWin() {
        //  this.normalWinContainer.scale.set(0)

        this.normalWinHolder = new PIXI.Sprite(PIXI.Assets.get("normalWinSparkle"));
        this.normalWinHolder.x = 0;
        this.normalWinHolder.y = -120;
        this.normalWinHolder.anchor.set(0.5);
        this.normalWinContainer.addChild(this.normalWinHolder);
        this.normalWinContainer.visible = false;

        this.normalWinContainer.scale.set(0.65);

        // this.normalWinBg = new PIXI.Sprite(PIXI.Assets.get("normalWinBg"));
        // this.normalWinBg.x = 0;
        // this.normalWinBg.y = 0;
        // this.normalWinBg.anchor.set(0.5);
        // this.normalWinHolder.addChild(this.normalWinBg);

        this.normalWinSparkle = new PIXI.Sprite(
            PIXI.Assets.get("normalWinSparkle")
        );
        this.normalWinSparkle.x = 0;
        this.normalWinSparkle.y = 0;
        this.normalWinSparkle.anchor.set(0.5);
        this.normalWinHolder.addChild(this.normalWinSparkle);

        this.normalWinTextContainer = new PIXI.Sprite(
            PIXI.Assets.get("normalWinContainer")
        );
        this.normalWinTextContainer.x = 0;
        this.normalWinTextContainer.y = 0 + 270;
        this.normalWinTextContainer.anchor.set(0.5);
        this.normalWinHolder.addChild(this.normalWinTextContainer);
        // this.normalWinHolder.addChild(this.winAmountText);

        this.normalWinText = new PIXI.Sprite(PIXI.Assets.get("normalWinText"));
        this.normalWinText.x = 0;
        this.normalWinText.y = 0;
        this.normalWinText.anchor.set(0.5);
        this.normalWinHolder.addChild(this.normalWinText);
        this.normalWinHolder.on("pointerdown", () => {
            this.onRemoved();
            clearTimeout(this.onClickRemove);
        });


        this.normalWinValueText = new PIXI.BitmapText("0", {
            fontName: "normal-font",
            fontSize: 35,
            align: "center",
            letterSpacing: -10, //-85,
        });

        this.normalWinValueText.y = 255;
        this.normalWinValueText.x = 10;
        this.normalWinValueText.anchor.set(0.5);
        this.normalWinValueText.visible = true;
        this.normalWinHolder.addChild(this.normalWinValueText);
    }

    createWinText() {
        this.winAmountText = new PIXI.BitmapText("0", {
            fontName: "normal-font",
            fontSize: 36,
            align: "center",
            letterSpacing: -10,
        });

        this.winAmountText.y = 255;
        this.winAmountText.x = 10;
        this.winAmountText.anchor.set(0.5);
        this.winAmountText.visible = true;
    }

    createLoseText() {
        this.loseMessage = new PIXI.BitmapText("Go\nAgain!", {
            fontName: "normal-font",
            fontSize: 19,
            align: "center",
            letterSpacing: -10,
        });
        this.loseMessage.anchor.set(0.5);
        this.loseMessage.x = 0;
        this.loseMessage.y = 175;
        this.winContainer.addChild(this.loseMessage);
        this.loseMessage.visible = false;

        const style = new PIXI.TextStyle({
            dropShadow: true,
            dropShadowAngle: 1,
            dropShadowBlur: 0,
            dropShadowColor: 0,
            stroke: 0,
            fill: "#fff000",
            fontFamily: "Arial",
            fontSize: 35,
            fontWeight: "700",
            align: "center",
        });

        const loseMessageChild = new PIXI.Text("Prizes out of reach!", style);
        loseMessageChild.y = 140;
        loseMessageChild.x = 0;
        loseMessageChild.anchor.set(0.5);

        this.loseMessage.addChild(loseMessageChild);
    }

    showWin() {
        this.winContainer.visible = true;
        if (fruitData.winType === this.winTypes.NORMAL_WIN) {
            tweenFadeAppear(this.backgroundBlur, true);
            this.startNormalWin();
            return;
        }

        playMainBg1(false);
        playMainBg2(false);
        playMainBg(false);
        this.onAdded();

    }

    decideWinType() {
        // if (globalData.winType === this.winTypes.NORMAL_WIN) {
        //     this.animationPrefix = 'big_win';
        // }
        this.winAmountText.interactive = false;
        if (fruitData.winType === this.winTypes.BIG_WIN) {
            setCommendationType(COMMENDATION.BIG);
            bigWin(
                this.backgroundBlur,
                this.winAmountText,
                fruitData.roundWinnings,
                this.winSpine
            );
            this.animationPrefix = "big_win";
            this.winAmountText.fontName = "bronze-font";
            // this.onClickRemove= setTimeout(() => {
            //     this.onRemoved();
            // }, 5000);
        } else if (fruitData.winType === this.winTypes.MEGA_WIN) {
            setCommendationType(COMMENDATION.MEGA);
            megaWin(
                this.backgroundBlur,
                this.winAmountText,
                fruitData.roundWinnings,
                this.winSpine
            );

            this.animationPrefix = "mega_win";
            this.winAmountText.fontName = "bronze-font";
            // this.onClickRemove= setTimeout(() => {
            //     this.onRemoved();
            // }, 5000);
        } else if (fruitData.winType === this.winTypes.ULTRA_WIN) {
            setCommendationType(COMMENDATION.ULTRA);
            ultraWin(
                this.backgroundBlur,
                this.winAmountText,
                fruitData.roundWinnings,
                this.winSpine
            );
            this.animationPrefix = "ultra_win";
            this.winAmountText.fontName = "bronze-font";
            // this.onClickRemove= setTimeout(() => {
            //     this.onRemoved();
            // }, 5000);
        }
    }

    onAdded() {
        this.decideWinType();
        this.winSpine.visible = true;


        this.winAmountText.zIndex = 100;
        this.minorJackpotSpine.zIndex = 100;
        this.majorJackpotSpine.zIndex = 100;
        this.grandJackpotSpine.zIndex = 100;

        this.winSpine.addChild(this.winAmountText);

    }

    createJackpotWinText() {
        this.minorJackpotText = new PIXI.BitmapText("0", {
            fontName: "normal-font",
            fontSize: 33,
            align: "center",
            letterSpacing: -10, //-85,
        });

        this.minorJackpotText.y = 265;
        this.minorJackpotText.x = 10;
        this.minorJackpotText.anchor.set(0.5);
        this.minorJackpotText.visible = false;

        //major
        this.majorJackpotText = new PIXI.BitmapText("0", {
            fontName: "normal-font",
            fontSize: 33,
            align: "center",
            letterSpacing: -10, //-85,
        });

        this.majorJackpotText.y = 265;
        this.majorJackpotText.x = 10;
        this.majorJackpotText.anchor.set(0.5);
        this.majorJackpotText.visible = false;

        //grand
        this.grandJackpotText = new PIXI.BitmapText("0", {
            fontName: "normal-font",
            fontSize: 33,
            align: "center",
            letterSpacing: -10, //-85,
        });

        this.grandJackpotText.y = 265;
        this.grandJackpotText.x = 10;
        this.grandJackpotText.anchor.set(0.5);
        this.grandJackpotText.visible = false;

        this.minorJackpotSpine.addChild(this.minorJackpotText);
        this.majorJackpotSpine.addChild(this.majorJackpotText);
        this.grandJackpotSpine.addChild(this.grandJackpotText);

        this.minorJackpotText.zIndex = 500;
        this.majorJackpotText.zIndex = 500;
        this.grandJackpotText.zIndex = 500;

        this.minorJackpotSpine.sortableChildren = true;
        this.majorJackpotSpine.sortableChildren = true;
        this.grandJackpotSpine.sortableChildren = true;
    }

    showLose() {
        this.winContainer.visible = true;
        tweenFadeAppear(this.backgroundBlur, true);
        this.loseMessage.visible = true;
        toggleVisibiltiyAndInteractivity(false);

        this.onClickRemove = setTimeout(() => {
            this.loseEnd();
        }, 5000);

        this.winContainer.interactive = true;

        this.winContainer.removeAllListeners('pointerdown');

        const onClickListener = () => {
            this.winContainer.off('pointerdown', onClickListener);
            this.winContainer.interactive = false;

            clearTimeout(this.onClickRemove);

            this.loseEnd();

        };

        this.winContainer.on('pointerdown', onClickListener);
    }


    loseEnd() {
        tweenFadeAppear(this.backgroundBlur, false)
        this.loseMessage.visible = false;
        this.winContainer.visible = false;
        console.log("from-lose-end");

        setTimeout(() => {
            restartGame();
        }, 300);
    }

    update(delta) {

        if (this.normalWin) {
            //   this.normalWinBg.angle += delta;
            this.normalWinSparkle.angle -= delta;
            if (this.normalWinHolder.scale.x < 1 && this.popUpNormalWin) {
                this.normalWinHolder.scale.x += delta * 0.05;
                this.normalWinHolder.scale.y += delta * 0.05;
            } else if (this.popUpNormalWin) {
                this.normalWinHolder.scale.x = 1;
                this.normalWinHolder.scale.y = 1;
                this.popUpNormalWin = false;
            }
        }
    }


    startNormalWin() {
        playCoinAnimation(0)
        this.normalWinContainer.visible = true;
        this.normalWinValueText.fontName = "normal-font"
        this.normalWinValueText.visible = true;

        this.normalWinHolder.interactive = true;
        this.normalWinValueText.text = 0;
        incrementValue(this.normalWinValueText, fruitData.roundWinnings, 8)
        this.normalWin = true;
        this.popUpNormalWin = true;

        // this.count = true;
        this.onClickRemove = setTimeout(() => {
            this.onRemoved();
        }, 5000);
    }

    jackpot() {
        this.winContainer.visible = true;
        if (fruitData.jackpotMinorWin) {
            fruitData.jackpotMinorWin = false;
            controlJackpotWinSpine(0, true);
            setCommendationType(COMMENDATION.MINOR);
            this.minorJackpotText.fontName = "bronze-font";
            minorJackpot(
                this.minorJackpotSpine,
                fruitData.jackpotMinorWinAmount,
                this.backgroundBlur,
                this.minorJackpotText
            );

        } else if (fruitData.jackpotMajorWin) {
            fruitData.jackpotMajorWin = false;
            controlJackpotWinSpine(0, false);
            controlJackpotWinSpine(1, true);
            setCommendationType(COMMENDATION.MAJOR);
            this.majorJackpotText.fontName = "silver-font";
            majorJackpot(
                this.majorJackpotSpine,
                fruitData.jackpotMajorWinAmount,
                this.backgroundBlur,
                this.majorJackpotText
            );
        } else if (fruitData.jackpotGrandWin) {
            fruitData.jackpotGrandWin = false;
            controlJackpotWinSpine(1, false);
            controlJackpotWinSpine(2, true);
            setCommendationType(COMMENDATION.GRAND);
            this.grandJackpotText.fontName = "gold-font";
            grandJackpot(
                this.grandJackpotSpine,
                fruitData.jackpotGrandWinAmount,
                this.backgroundBlur,
                this.grandJackpotText
            );
        }
    }

    onRemoved() {
        // tweenFadeAppear(this.backgroundBlur, false);
        this.winAmountText.visible = false;
        if (!this.normalWin) {
            this.winSpine.state.setAnimation(0, this.animationPrefix + "_out", true);
            // this.winSpine.state.addListener({
            //     complete: (e) => {
            //         this.winSpine.visible = false;
            //         this.winSpine.interactive = false;
            //         this.normalWinHolder.interactive = false
            //         this.winSpine.removeChild(this.winAmountText);
            //         restartGame();
            //     }
            // })
            setTimeout(() => {
                this.winSpine.visible = false;
                this.winSpine.interactive = false;
                this.normalWinHolder.interactive = false;
                this.winSpine.removeChild(this.winAmountText);
                console.log("from-normal-win-1");

                restartGame();
            }, 450);
        } else {
            stopCoinAnimation()
            this.normalWin = false;
            this.winSpine.interactive = false;
            this.normalWinHolder.interactive = false;
            this.normalWinValueText.visible = false;
            // this.normalWinHolder.removeChild(this.normalWinValueText);
            if (!fruitData.jackpotMajorWin && !fruitData.jackpotGrandWin && !fruitData.jackpotMinorWin) {
                tweenFadeAppear(this.backgroundBlur, false);
                this.normalWinContainer.visible = false;

                restartGame();
            } else {
                this.normalWinContainer.visible = false;
                this.minorJackpotSpine.addChild(this.minorJackpotText);
                this.majorJackpotSpine.addChild(this.majorJackpotText);
                this.grandJackpotSpine.addChild(this.grandJackpotText);

                this.minorJackpotText.zIndex = 500;
                this.majorJackpotText.zIndex = 500;
                this.grandJackpotText.zIndex = 500;

                this.minorJackpotSpine.sortableChildren = true;
                this.majorJackpotSpine.sortableChildren = true;
                this.grandJackpotSpine.sortableChildren = true;
                this.jackpot()
            }


        }
        //  this.winAmount = 0;
    }
}